import { useTranslate } from "@similarweb/i18n-provider";

import { ModalHeader } from "../../../common/modal/ModalHeader";

interface IHeaderProps {
    domain: string;
    favicon: string;
    adCounter: string;
    onClose: () => void;
}

export const Header = ({ domain, favicon, adCounter, onClose }: IHeaderProps) => {
    const { translate } = useTranslate();

    return (
        <ModalHeader
            domain={domain}
            favicon={favicon}
            onClose={onClose}
        >
            <ModalHeader.InfoGroup title={translate("activation.alerts.cards.display-ads.modal.header.new-ads")}>
                {adCounter}
            </ModalHeader.InfoGroup>
        </ModalHeader>
    );
};
